import { computed } from 'vue'
import type { VoiceNotesState } from './state'

export const createGetters = (state: VoiceNotesState) => {
  const sessionCount = computed(() => state.sessions.length)
  const fragmentCount = computed(() => state.fragments.length)

  const totalDuration = computed(() => {
    return state.fragments.reduce((sum, f) => sum + f.duration, 0)
  })

  return {
    sessionCount,
    fragmentCount,
    totalDuration,
  }
}
